"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const tapeBuilderNodeId = (0, uuid_1.v4)();
    const operationNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: task,
    };
    return operationNode;
};
const taskFromOperationNode = ({ operationNode, }) => {
    const { configuration } = operationNode;
    return {
        ...configuration,
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'join',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    getInputSlugs: (task) => [task.srcArtifactSlug, task.joinArtifactSlug],
    toTransformation: (task, resolveDef) => {
        const { srcArtifactSlug, joinArtifactSlug, ...restOfJoinParams } = task;
        const srcDataTape = resolveDef(srcArtifactSlug);
        const joinDataTape = resolveDef(joinArtifactSlug);
        if (srcDataTape.isValid && joinDataTape.isValid) {
            (0, common_1.finleyAssert)(srcDataTape.data && joinDataTape.data, 'TapeDefinition is null for join operation inputs ');
            return {
                isValid: true,
                data: {
                    srcDataTape: srcDataTape.data,
                    joinDataTape: joinDataTape.data,
                    ...restOfJoinParams,
                },
            };
        }
        const errors = [];
        if (!srcDataTape.isValid) {
            errors.push(...srcDataTape.errors);
        }
        if (!joinDataTape.isValid) {
            errors.push(...joinDataTape.errors);
        }
        return {
            isValid: false,
            errors,
        };
    },
};
//# sourceMappingURL=converter.js.map